<template>
    <div class="newsVideoCenter">
        <a class="borderLine borderTop newTitleBox yahei" href="javascript:;" @click="gotoList('comNews')">新闻中心</a>
        <div class="borderLine list">
            <newsList :dataList="newsList"></newsList>
        </div>
        <a class="borderLine borderTop newTitleBox yahei mt30" href="javascript:;" @click="gotoList('comVideo')">视频中心</a>
        <div class="borderLine list">
            <videoList :dataList="videoList"></videoList>
        </div>
    </div>
</template>
a
<script>
import newsList from "./newsList";
import videoList from "./videoList";
export default {
    name: "newsVideoCenter",
    props:["newsList","videoList"],
    methods:{
        gotoList(pathName){
            console.log('comNews')
            this.$router.push({name:pathName});
        }
    },

    components:{
        newsList,
        videoList,
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.newsVideoCenter{
}
</style>